import styled from 'styled-components';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

export const MakerBadgeContainer = styled.div`
  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0.5rem;
  }
`;
